import Default from './Default';

const CalculadoraDefault = Default

export default CalculadoraDefault;
